import type { SelectItem } from '@nuxt/ui'

// O Moodle exige a sigla ISO alpha-2 no atributo 'value'
export const countryOptions: SelectItem[] = [
  { label: 'Brasil', value: 'BR' },
  { label: 'Afeganistão', value: 'AF' },
  { label: 'África do Sul', value: 'ZA' },
  { label: 'Albânia', value: 'AL' },
  { label: 'Alemanha', value: 'DE' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Antígua e Barbuda', value: 'AG' },
  { label: 'Arábia Saudita', value: 'SA' },
  { label: 'Argélia', value: 'DZ' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armênia', value: 'AM' },
  { label: 'Austrália', value: 'AU' },
  { label: 'Áustria', value: 'AT' },
  { label: 'Azerbaijão', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Bahrein', value: 'BH' },
  { label: 'Bélgica', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benim', value: 'BJ' },
  { label: 'Bielorrússia', value: 'BY' },
  { label: 'Bolívia', value: 'BO' },
  { label: 'Bósnia e Herzegovina', value: 'BA' },
  { label: 'Botsuana', value: 'BW' },
  { label: 'Brunei', value: 'BN' },
  { label: 'Bulgária', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Butão', value: 'BT' },
  { label: 'Cabo Verde', value: 'CV' },
  { label: 'Camarões', value: 'CM' },
  { label: 'Camboja', value: 'KH' },
  { label: 'Canadá', value: 'CA' },
  { label: 'Catar', value: 'QA' },
  { label: 'Cazaquistão', value: 'KZ' },
  { label: 'Chade', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Chipre', value: 'CY' },
  { label: 'Colômbia', value: 'CO' },
  { label: 'Comores', value: 'KM' },
  { label: 'Congo-Brazzaville', value: 'CG' },
  { label: 'Coreia do Norte', value: 'KP' },
  { label: 'Coreia do Sul', value: 'KR' },
  { label: 'Costa do Marfim', value: 'CI' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Croácia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Dinamarca', value: 'DK' },
  { label: 'Djibuti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Egito', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Emirados Árabes Unidos', value: 'AE' },
  { label: 'Equador', value: 'EC' },
  { label: 'Eritreia', value: 'ER' },
  { label: 'Eslováquia', value: 'SK' },
  { label: 'Eslovênia', value: 'SI' },
  { label: 'Espanha', value: 'ES' },
  { label: 'Estados Unidos', value: 'US' },
  { label: 'Estônia', value: 'EE' },
  { label: 'Eswatini', value: 'SZ' },
  { label: 'Etiópia', value: 'ET' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Filipinas', value: 'PH' },
  { label: 'Finlândia', value: 'FI' },
  { label: 'França', value: 'FR' },
  { label: 'Gabão', value: 'GA' },
  { label: 'Gâmbia', value: 'GM' },
  { label: 'Gana', value: 'GH' },
  { label: 'Geórgia', value: 'GE' },
  { label: 'Granada', value: 'GD' },
  { label: 'Grécia', value: 'GR' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guiana', value: 'GY' },
  { label: 'Guiné', value: 'GN' },
  { label: 'Guiné-Bissau', value: 'GW' },
  { label: 'Guiné Equatorial', value: 'GQ' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hungria', value: 'HU' },
  { label: 'Iêmen', value: 'YE' },
  { label: 'Ilhas Marshall', value: 'MH' },
  { label: 'Ilhas Salomão', value: 'SB' },
  { label: 'Índia', value: 'IN' },
  { label: 'Indonésia', value: 'ID' },
  { label: 'Irã', value: 'IR' },
  { label: 'Iraque', value: 'IQ' },
  { label: 'Irlanda', value: 'IE' },
  { label: 'Islândia', value: 'IS' },
  { label: 'Israel', value: 'IL' },
  { label: 'Itália', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japão', value: 'JP' },
  { label: 'Jordânia', value: 'JO' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Kosovo', value: 'XK' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Laos', value: 'LA' },
  { label: 'Lesoto', value: 'LS' },
  { label: 'Letônia', value: 'LV' },
  { label: 'Líbano', value: 'LB' },
  { label: 'Libéria', value: 'LR' },
  { label: 'Líbia', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lituânia', value: 'LT' },
  { label: 'Luxemburgo', value: 'LU' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malásia', value: 'MY' },
  { label: 'Malaui', value: 'MW' },
  { label: 'Maldivas', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marrocos', value: 'MA' },
  { label: 'Maurício', value: 'MU' },
  { label: 'Mauritânia', value: 'MR' },
  { label: 'México', value: 'MX' },
  { label: 'Micronésia', value: 'FM' },
  { label: 'Moçambique', value: 'MZ' },
  { label: 'Moldávia', value: 'MD' },
  { label: 'Mônaco', value: 'MC' },
  { label: 'Mongólia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namíbia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Nicarágua', value: 'NI' },
  { label: 'Níger', value: 'NE' },
  { label: 'Nigéria', value: 'NG' },
  { label: 'Noruega', value: 'NO' },
  { label: 'Nova Zelândia', value: 'NZ' },
  { label: 'Omã', value: 'OM' },
  { label: 'Países Baixos', value: 'NL' },
  { label: 'Palau', value: 'PW' },
  { label: 'Panamá', value: 'PA' },
  { label: 'Papua Nova Guiné', value: 'PG' },
  { label: 'Paquistão', value: 'PK' },
  { label: 'Paraguai', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Polônia', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Quênia', value: 'KE' },
  { label: 'Quirguistão', value: 'KG' },
  { label: 'Reino Unido', value: 'GB' },
  { label: 'República Centro-Africana', value: 'CF' },
  { label: 'República Democrática do Congo', value: 'CD' },
  { label: 'República Dominicana', value: 'DO' },
  { label: 'República Tcheca', value: 'CZ' },
  { label: 'Romênia', value: 'RO' },
  { label: 'Ruanda', value: 'RW' },
  { label: 'Rússia', value: 'RU' },
  { label: 'Samoa', value: 'WS' },
  { label: 'São Cristóvão e Neves', value: 'KN' },
  { label: 'São Marino', value: 'SM' },
  { label: 'São Tomé e Príncipe', value: 'ST' },
  { label: 'São Vicente e Granadinas', value: 'VC' },
  { label: 'Seicheles', value: 'SC' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serra Leoa', value: 'SL' },
  { label: 'Sérvia', value: 'RS' },
  { label: 'Singapura', value: 'SG' },
  { label: 'Síria', value: 'SY' },
  { label: 'Somália', value: 'SO' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Sudão', value: 'SD' },
  { label: 'Sudão do Sul', value: 'SS' },
  { label: 'Suécia', value: 'SE' },
  { label: 'Suíça', value: 'CH' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Tajiquistão', value: 'TJ' },
  { label: 'Tailândia', value: 'TH' },
  { label: 'Tanzânia', value: 'TZ' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad e Tobago', value: 'TT' },
  { label: 'Tunísia', value: 'TN' },
  { label: 'Turcomenistão', value: 'TM' },
  { label: 'Turquia', value: 'TR' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Ucrânia', value: 'UA' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Uruguai', value: 'UY' },
  { label: 'Uzbequistão', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Vaticano', value: 'VA' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Vietnã', value: 'VN' },
  { label: 'Zâmbia', value: 'ZM' },
  { label: 'Zimbábue', value: 'ZW' }
];